import { c as _c } from "react/compiler-runtime";
import { Stack, Typography } from '@mui/material';
import { MultiSectionDigitalClock, TimeField } from '@mui/x-date-pickers';
import { type KeyboardEvent } from 'react';
import { type Dayjs } from '@/utils/dayjs';
const handleTimeFieldKeyDown = (e: KeyboardEvent<HTMLDivElement>) => {
  if (e.key === 'Tab') {
    e.preventDefault();
    const arrowKey = e.shiftKey ? 'ArrowLeft' : 'ArrowRight';
    e.currentTarget.dispatchEvent(new KeyboardEvent('keydown', {
      key: arrowKey,
      bubbles: true
    }));
  }
};
export const TimePicker = t0 => {
  const $ = _c(43);
  const {
    value,
    setValue,
    title: t1,
    showSeconds: t2,
    minTime,
    maxTime
  } = t0;
  const title = t1 === undefined ? "Time:" : t1;
  const showSeconds = t2 === undefined ? false : t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      gap: "24px"
    };
    $[0] = t3;
  } else {
    t3 = $[0];
  }
  let t4;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      justifyContent: "space-between"
    };
    $[1] = t4;
  } else {
    t4 = $[1];
  }
  let t5;
  if ($[2] !== title) {
    t5 = <Typography variant="subtitle1" className="mt-[4px]">{title}</Typography>;
    $[2] = title;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  const t6 = showSeconds ? "HH:mm:ss" : "HH:mm";
  let t7;
  if ($[4] !== setValue) {
    t7 = value_0 => {
      if (value_0) {
        setValue(value_0);
      }
    };
    $[4] = setValue;
    $[5] = t7;
  } else {
    t7 = $[5];
  }
  const t8 = showSeconds ? "100px" : "80px";
  let t10;
  let t11;
  let t9;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = {
      padding: 0,
      fontSize: "13px"
    };
    t10 = {
      padding: "4px 12px"
    };
    t11 = {
      border: "1px solid var(--mui-palette-primary-main)"
    };
    $[6] = t10;
    $[7] = t11;
    $[8] = t9;
  } else {
    t10 = $[6];
    t11 = $[7];
    t9 = $[8];
  }
  let t12;
  if ($[9] !== t8) {
    t12 = {
      width: t8,
      "& .MuiInputBase-root": t9,
      "& .MuiOutlinedInput-input": t10,
      "& .MuiOutlinedInput-notchedOutline": t11
    };
    $[9] = t8;
    $[10] = t12;
  } else {
    t12 = $[10];
  }
  let t13;
  if ($[11] !== maxTime || $[12] !== minTime || $[13] !== t12 || $[14] !== t6 || $[15] !== t7 || $[16] !== value) {
    t13 = <TimeField ampm={false} minTime={minTime} maxTime={maxTime} format={t6} value={value} onKeyDown={handleTimeFieldKeyDown} onChange={t7} sx={t12} />;
    $[11] = maxTime;
    $[12] = minTime;
    $[13] = t12;
    $[14] = t6;
    $[15] = t7;
    $[16] = value;
    $[17] = t13;
  } else {
    t13 = $[17];
  }
  let t14;
  if ($[18] !== t13 || $[19] !== t5) {
    t14 = <Stack direction="row" sx={t4}>{t5}{t13}</Stack>;
    $[18] = t13;
    $[19] = t5;
    $[20] = t14;
  } else {
    t14 = $[20];
  }
  let t15;
  if ($[21] !== showSeconds) {
    t15 = showSeconds ? ["hours", "minutes", "seconds"] : ["hours", "minutes"];
    $[21] = showSeconds;
    $[22] = t15;
  } else {
    t15 = $[22];
  }
  let t16;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = {
      minutes: 1,
      seconds: 1
    };
    $[23] = t16;
  } else {
    t16 = $[23];
  }
  let t17;
  if ($[24] !== setValue) {
    t17 = value_1 => {
      if (value_1) {
        setValue(value_1);
      }
    };
    $[24] = setValue;
    $[25] = t17;
  } else {
    t17 = $[25];
  }
  const t18 = showSeconds ? "33.33%" : "50%";
  let t19;
  if ($[26] !== t18) {
    t19 = {
      flexGrow: 1,
      width: t18,
      padding: "4px",
      maxHeight: "100%"
    };
    $[26] = t18;
    $[27] = t19;
  } else {
    t19 = $[27];
  }
  let t20;
  let t21;
  let t22;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t20 = {
      padding: "12px 8px",
      width: "100%",
      margin: 0,
      justifyContent: "start",
      "&:hover": {
        backgroundColor: "var(--mui-palette-primary-dark)"
      }
    };
    t21 = {
      backgroundColor: "var(--mui-palette-primary-dark) !important"
    };
    t22 = {
      backgroundColor: "var(--mui-palette-primary-main) !important"
    };
    $[28] = t20;
    $[29] = t21;
    $[30] = t22;
  } else {
    t20 = $[28];
    t21 = $[29];
    t22 = $[30];
  }
  let t23;
  if ($[31] !== t19) {
    t23 = {
      flexGrow: 1,
      border: "1px solid var(--mui-palette-divider)",
      "& .MuiList-root": t19,
      "& .MuiMenuItem-root": t20,
      "& .Mui-focusVisible": t21,
      "& .Mui-focusVisible.Mui-selected": t22
    };
    $[31] = t19;
    $[32] = t23;
  } else {
    t23 = $[32];
  }
  let t24;
  if ($[33] !== maxTime || $[34] !== minTime || $[35] !== t15 || $[36] !== t17 || $[37] !== t23 || $[38] !== value) {
    t24 = <MultiSectionDigitalClock autoFocus={false} minTime={minTime} maxTime={maxTime} ampm={false} views={t15} timeSteps={t16} value={value} onChange={t17} sx={t23} />;
    $[33] = maxTime;
    $[34] = minTime;
    $[35] = t15;
    $[36] = t17;
    $[37] = t23;
    $[38] = value;
    $[39] = t24;
  } else {
    t24 = $[39];
  }
  let t25;
  if ($[40] !== t14 || $[41] !== t24) {
    t25 = <Stack className="p-[24px] w-[308px] h-[348px]" sx={t3}>{t14}{t24}</Stack>;
    $[40] = t14;
    $[41] = t24;
    $[42] = t25;
  } else {
    t25 = $[42];
  }
  return t25;
};